export default __webpack_public_path__ + "static/media/image-gallery-gif.87f5ebe6.gif";